export default __webpack_public_path__ + "static/media/img-0665-albania-full-face.32f92d25.png";